import { SVGProps } from 'react';

const TurkishLira = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15 4 5 9m10-.5-10 5M18 12a9 9 0 0 1-9 9V3"
    />
  </svg>
);
export default TurkishLira;
